/* card-nav-fix.js — make product cards reliably navigate on tap/click.

   WHY: the Variant Swatch King app marks every product card (<li swatch-generated>)
   and injects a <variant-swatch-king> overlay. Its handlers mutate the card's
   media between mousedown and mouseup, so the browser retargets the `click` event
   to a non-link ancestor (the card <div>) instead of the product <a>. The native
   anchor therefore never navigates — most visibly on the search results grid,
   where tapping a product did nothing. (A programmatic a.click() still worked,
   which is why the links looked fine in markup.)

   FIX: a capture-phase delegated handler. If a click lands inside a product card
   and did NOT resolve to a real anchor or an interactive control, navigate to the
   card's product URL ourselves. Capture phase means it still fires even if an app
   stops propagation. Modifier-clicks (new tab) and real controls are left alone. */
(function () {
  document.addEventListener(
    'click',
    function (e) {
      if (e.defaultPrevented) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      // Leave genuine controls and swatch/wishlist/quick-add widgets untouched.
      if (
        e.target.closest(
          'button, input, select, textarea, label, summary, details, [contenteditable], [data-wishlist-toggle], [data-wl-open], variant-swatch-king, .swatches, .quick-add, .shopify-pc__banner'
        )
      )
        return;
      // If a real anchor received the click, the browser will navigate natively.
      if (e.target.closest('a[href]')) return;
      var card = e.target.closest(
        '.card-wrapper, .product-card-wrapper, .hpc-card, .hpc__card, .igp, li[swatch-generated], li.grid__item'
      );
      if (!card) return;
      var link = card.querySelector('a[href*="/products/"]');
      if (link) window.location.href = link.getAttribute('href');
    },
    true
  );
})();
